<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="计划" prop="planId" >
        <a-select v-model="form.planId" placeholder="请选择计划">
          <a-select-option v-for="item in planOptions" :value="item.id" :key='item.id'>{{item.title}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="排序" prop="seq" >
        <a-input v-model="form.seq" placeholder="请输入排序" />
      </a-form-model-item>
      <a-form-model-item label="是否准备日" prop="type" >
        <a-select v-model="form.type">
          <a-select-option :value="0">否</a-select-option>
          <a-select-option :value="1">是</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-if="form.type == 1" label="准备日内容" prop="content" >
        <editor v-model="form.content" />
      </a-form-model-item>
      <a-form-model-item label="千卡" prop="kilocalorie" >
        <a-input-number v-model="form.kilocalorie" />
      </a-form-model-item>
      <a-form-model-item label="蛋白质份量g" prop="proteinWeight" >
        <a-input-number v-model="form.proteinWeight" />
      </a-form-model-item>
      <a-form-model-item label="蛋白质含量百分比%" prop="proteinRatio" >
        <a-input-number v-model="form.proteinRatio" />
      </a-form-model-item>
      <a-form-model-item label="碳水化合物份量" prop="carbohydrateWeight" >
        <a-input-number v-model="form.carbohydrateWeight" />
      </a-form-model-item>
      <a-form-model-item label="碳水化合物含量百分比%" prop="carbohydrateRatio" >
        <a-input-number v-model="form.carbohydrateRatio" />
      </a-form-model-item>
      <a-form-model-item label="脂肪份量g" prop="fatWeight" >
        <a-input-number v-model="form.fatWeight" />
      </a-form-model-item>
      <a-form-model-item label="脂肪含量百分比%" prop="fatRatio" >
        <a-input-number v-model="form.fatRatio" />
      </a-form-model-item>
      <a-form-model-item label="批量生成天数" prop="days" v-if="bathAdd == 1">
        <a-input-number style="width: 300px" :min="0" v-model="form.days" placeholder="请输入天数"  allow-clear />
      </a-form-model-item>
      <a-form-model-item label="早餐食物推荐" prop="breakfast" >
        <a-select
          mode="multiple"
          placeholder="选择食物"
          style="width: 100%"
          :value="breakfasts"
          @change="selectBreakfast"
          @search="breakfastSelect"
          :filterOption="false"
        >
          <a-select-option :value="item.id" v-for="item in foodList"  :key='item.id'>
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="午餐食物推荐" prop="lunch" >
        <a-select
          mode="multiple"
          placeholder="选择食物"
          style="width: 100%"
          :value="lunchs"
          @change="selectLunch"
          @search="lunchSelect"
          :filterOption="false"
        >
          <a-select-option :value="item.id" v-for="item in foodList"  :key='item.id'>
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="晚餐食物推荐" prop="dinner" >
        <a-select
          placeholder="选择食物"
          style="width: 100%"
          :value="dinners"
          mode="multiple"
          @change="selectDinner"
          @search="dinnerSelect"
          :filterOption="false"
        >
          <a-select-option :value="item.id" v-for="item in foodList"  :key='item.id'>
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
<!--      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getDayInfo, addDayInfo, updateDayInfo } from '@/api/plan/dayInfo'
import Editor from '@/components/Editor'

import {listPlan} from '@/api/cookbook/plan'

export default {
  name: 'CreateFormDate',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      // 已选择早餐食物id列表
      breakfasts: [],
      // 已选择午餐食物id列表
      lunchs: [],
      // 已选择晚餐食物id列表
      dinners: [],
      // 所有食物列表
      foodList: [],
      bathAdd:0,
      planOptions: [],
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        planId: null,

        seq: null,

        type: null,
        days:null,

        content: null,

        kilocalorie: null,

        proteinWeight: null,

        proteinRatio: null,

        carbohydrateWeight: null,

        carbohydrateRatio: null,

        fatWeight: null,

        fatRatio: null,

        breakfast: null,

        lunch: null,

        dinner: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        planId: [
          { required: true, message: '计划ID ｛plan.id｝不能为空', trigger: 'blur' }
        ],
        seq: [
          { required: true, message: '排序不能为空', trigger: 'blur' }
        ],
        days: [
          { required: true, message: '批量生成天数不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '是否准备日 0-否 1-是不能为空', trigger: 'change' }
        ],
        content: [
          { required: true, message: '准备日内容不能为空', trigger: 'blur' }
        ],
        kilocalorie: [
          { required: true, message: '千卡不能为空', trigger: 'blur' }
        ],
        proteinWeight: [
          { required: true, message: '蛋白质份量g不能为空', trigger: 'blur' }
        ],
        proteinRatio: [
          { required: true, message: '蛋白质含量百分比%不能为空', trigger: 'blur' }
        ],
        carbohydrateWeight: [
          { required: true, message: '碳水化合物份量不能为空', trigger: 'blur' }
        ],
        carbohydrateRatio: [
          { required: true, message: '碳水化合物含量百分比%不能为空', trigger: 'blur' }
        ],
        fatWeight: [
          { required: true, message: '脂肪份量g不能为空', trigger: 'blur' }
        ],
        fatRatio: [
          { required: true, message: '脂肪含量百分比%不能为空', trigger: 'blur' }
        ],
        /*breakfast: [
          { required: true, message: '早餐食物推荐[{id:21312,name:1231,image:1513,weight:123131,kilocalorie:321231}]不能为空', trigger: 'blur' }
        ],
        lunch: [
          { required: true, message: '午餐食物推荐[{id:21312,name:1231,image:1513,weight:123131,kilocalorie:321231}]不能为空', trigger: 'blur' }
        ],
        dinner: [
          { required: true, message: '晚餐食物推荐[{id:21312,name:1231,image:1513,weight:123131,kilocalorie:321231}]不能为空', trigger: 'blur' }
        ]*/
      }
    }
  },
  filters: {
  },
  created () {
    this.getFoodList()
    this.getPlanOptions()
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    dinnerSelect(item) {
      pageFood({pageSize:10, nameAccurate:item}).then(res=>{
        this.foodList = res.data.records
      })
    },
    lunchSelect(item) {
      pageFood({pageSize:10, nameAccurate:item}).then(res=>{
        this.foodList = res.data.records
      })
    },
    breakfastSelect(item) {

      pageFood({pageSize:10, nameAccurate:item}).then(res=>{
        this.foodList = res.data.records
      })
    },
    getPlanOptions() {
      listPlan().then(res => {
        this.planOptions = res.data
      })
    },
    onClose () {
      this.open = false
    },
    // 选择早餐处理
    selectBreakfast(items) {
      this.breakfasts = items
    },
    // 选择早餐处理
    selectLunch(items) {
      this.lunchs = items
    },
    // 选择早餐处理
    selectDinner(items) {
      this.dinners = items
    },
    // 获取食物列表
    getFoodList() {
      pageFood({pageSize:10}).then(res=>{
        this.foodList = res.data.records
      })
    },

    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.bathAdd = 0
      this.breakfasts = []
      this.lunchs = []
      this.dinners = []
      this.form = {
        id: null,
        planId: null,
        seq: null,
        days:null,
        type: null,
        content: null,
        kilocalorie: null,
        proteinWeight: null,
        proteinRatio: null,
        carbohydrateWeight: null,
        carbohydrateRatio: null,
        fatWeight: null,
        fatRatio: null,
        breakfast: null,
        lunch: null,
        dinner: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row, ids) {
      const id = row ? row.id : ids
      this.reset()
      this.formType = 1
      this.open = true
      this.form.planId =id
      this.formTitle = '添加'
    },
    batchAdd(){
      this.reset()
      this.formType = 1
      this.bathAdd = 1
      this.open = true
      this.formTitle = '批量添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getDayInfo({"id":id}).then(response => {
        this.form = response.data
        this.breakfasts = this.form.breakfast.split(",")
        this.lunchs = this.form.lunch.split(",")
        this.dinners = this.form.dinner.split(",")
        this.foodList = [... this.form.breakfastList, ... this.form.dinnerList, ... this.form.lunchList]
          this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.form.breakfast = this.breakfasts.toString()
          this.form.lunch = this.lunchs.toString()
          this.form.dinner = this.dinners.toString()
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateDayInfo(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addDayInfo(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
